import { Text } from "@ttc3k/trekker";
import { useStorefrontByIdQuery } from "gql/generated.ts";
import { getMultilingualString } from "shared/utils";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";
import { Divider } from "styled-system/jsx";

type StorefrontMenuProps = {
  storefrontId: string;
};

export const StorefrontMenu = ({ storefrontId }: StorefrontMenuProps) => {
  const { data, error, loading } = useStorefrontByIdQuery({
    variables: { id: storefrontId },
  });

  if (loading) return <SimpleLoader />;

  if (error) return <SimpleErrorNotification />;

  if (!data || !data.storefrontById) {
    return null;
  }

  return (
    <>
      <Divider
        orientation={"vertical"}
        thickness={"2px"}
        height={"16px"}
        color={"border.light"}
      />
      <Text visual={"smallMedium"} color={"text.dark"}>
        {getMultilingualString(data.storefrontById.name)}
      </Text>
    </>
  );
};
